






















import { Watch, Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class InputRadio extends Vue {
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly value!: string
    @Prop() readonly inputValue!: string
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    internalValue: string = null

    created() {
        this.onExternalChange()
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    onInternalChange(): void {
        this.$emit('input', this.internalValue)
    }

    get isChecked(): boolean {
        return this.internalValue === this.inputValue
    }

    get componentClass(): object {
        return {
            'input-radio': true,
            'input-radio--checked': this.isChecked,
        }
    }
}
